import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TreeViewMenuButtonMeasuresConstantType,
    TreeViewMenuButtonDynamicStyleType,
    TreeViewMenuButtonMeasures
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const getTreeViewMenuButtonMeasures = ({
    touchTargets,
    iconSizes,
    radiuses,
    measures
}: TreeViewMenuButtonMeasuresConstantType): TreeViewMenuButtonMeasures => {
    const hitSize = Math.max(measures.actionSize, Math.min(touchTargets.fine, measures.rowHeight));

    return {
        radius: concentric({
            inset: (measures.rowHeight - measures.actionSize) / 2,
            outer: measures.radius,
            role: radiuses.actions
        }),
        marginEnd: (iconSizes.small - hitSize) / 2,
        iconSize: iconSizes.small,
        size: measures.actionSize,
        hitSize
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    surface: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    shapeConfigs,
    isVisible,
    measures
}: TreeViewMenuButtonDynamicStyleType) => {
    const styles = {
        container: {
            marginEnd: measures.marginEnd,
            height: measures.hitSize,
            width: measures.hitSize,
            ...webStyle({
                cursor: "pointer"
            })
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: measures.radius,
                shapeConfigs
            }),
            height: measures.size,
            width: measures.size
        } as Mutable<ViewStyle>
    };

    if(!isVisible) {
        Object.assign(styles.container, webStyle({
            visibility: "hidden"
        }));
    }

    return styles;
};
export default stylesheet;
